module.exports = __webpack_public_path__ + "static/media/caret-down-space.45efe0ee.svg";